const settings = {
  name: 'Configuracion',
  tabs: {
    general: 'General',
    categories: 'Categorias',
    tags: 'Etiquetas',
  },
  general: {
    appInfo: 'Informacion de la aplicacion',
    systemInfo: 'Informacion del sistema',
    appName: 'Nombre de la aplicacion',
    version: 'Version',
    environment: 'Entorno',
    apiUrl: 'URL de la API',
    framework: 'Framework',
    uiLibrary: 'Libreria UI',
  },
  fields: {
    name: 'Nombre',
    description: 'Descripcion',
    status: 'Estado',
    color: 'Color',
    createdAt: 'Fecha de creacion',
    updatedAt: 'Fecha de actualizacion',
  },
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
  },
};

export default settings;
